import { Order, OrderStatus } from "@/types";
import { avatarIds } from "@/utils/get-avatar";
import { getRandomArrayElement } from "@/utils/get-random-array-element";
import { PiCheckCircleDuotone } from "react-icons/pi";
import { Avatar, Badge, Text, Title } from "rizzui";

interface DeliveryDetailsProps {
    order: Order;
}

export default function OrderSection({ order }: DeliveryDetailsProps) {
    return (
        <div className="py-6 px-4 rounded border border-muted">
            <div key={order.id} className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <Avatar
                        src={getRandomArrayElement(avatarIds)}
                        size="md"
                        className="mr-4"
                        name={""}
                    />
                    <div>
                        <Title as="h4" className="mb-1">
                            {order?.client?.fullname}
                        </Title>
                        <div className="flex items-center gap-2">
                            <Text className="text-gray-500">
                                {order?.client?.email}
                            </Text>
                            <span className="mr-1">•</span>
                            <Text className="text-gray-500">
                                <span className="mr-1">
                                    {order?.client?.phoneNumber}
                                </span>
                            </Text>
                            <span className="mr-1">•</span>
                            <Text className="text-gray-500">
                                {order.createdDate &&
                                    new Date(
                                        order?.createdDate,
                                    ).toLocaleString()}
                            </Text>
                        </div>
                    </div>
                </div>
                {order.status === OrderStatus.Delivered ? (
                    <Badge color="success" variant="flat" rounded="md">
                        {order.status}
                    </Badge>
                ) : order.status === OrderStatus.Requested ? (
                    <Badge color="warning" variant="flat" rounded="md">
                        {order.status}
                    </Badge>
                ) : order.status === OrderStatus.Cancelled ? (
                    <Badge color="danger" variant="flat" rounded="md">
                        {order.status}
                    </Badge>
                ) : order.status === OrderStatus.Processing ? (
                    <Badge color="secondary" variant="flat" rounded="md">
                        {order.status}
                    </Badge>
                ) : order.status === OrderStatus.Purchased ? (
                    <Badge color="primary" variant="flat" rounded="md">
                        {order.status}
                    </Badge>
                ) : order.status === OrderStatus.InTransit ? (
                    <Badge color="info" variant="flat" rounded="md">
                        {order.status}
                    </Badge>
                ) : order.status === OrderStatus.Rejected ? (
                    <Badge color="danger" variant="flat" rounded="md">
                        {order.status}
                    </Badge>
                ) : null}
            </div>
        </div>
    );
}
